export default __webpack_public_path__ + "static/media/pictogramBeaconSuperannuation40.4eda384d.svg";